<template>
  <View variant="tertiary" size="medium" gap="sm" padding="md" :class="['hint', ...classList]">
    <div class="icon" v-if="$slots.icon">
      <slot name="icon" />
    </div>

    <Icon v-else-if="icon" :name="icon!" class="icon" />

    <Text variant="body-medium" color="primary" class="hint-text">
      <slot />
    </Text>
  </View>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { IconName } from '../values/icons.const';
import Icon from './icon.vue';
import Text from './text.vue';
import View from './view/view.vue';

const props = withDefaults(
  defineProps<{
    icon?: IconName;
    type?: 'info' | 'error';
  }>(),
  {
    type: 'info',
  },
);

const classList = computed(() => [`type-${props.type}`]);
</script>

<style scoped lang="scss">
.hint {
  border-radius: var(--t-border-radius-sm);

  &.type-info {
    background-color: var(--t-color-neutral-100);
  }

  &.type-error {
    background-color: var(--t-color-red-200);
    color: var(--t-color-red-500);
  }
}

.hint-text {
  width: 100%;
  align-self: center;
}

.icon {
  flex-shrink: 0;
}
</style>
